import {
  getFacet,
  getText,
  appendGOATandCountryCodeToTitle,
  sortAndSliceList,
  constructList,
} from 'shared/utils/pageMetadataUtils';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.getTimelineMetadata';

export const getTimelineMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  query,
}) => {
  // Pulling out static strings for translation purposes
  const year: string = query?.timelineYear[0];
  const { facets = [] } = constructorResponse?.response || {};
  const brandFacet = getFacet(facets, 'brand');
  const topThreeBrands = sortAndSliceList(brandFacet?.options);
  const categoryFacet = getFacet(facets, 'web_groups');
  const itemCount: number = categoryFacet?.options.find(
    (option) => option.value === 'sneakers',
  )?.count;

  if (year === 'future') {
    const title = t(`${TP}.futureTitle`, 'Upcoming Sneaker Releases');
    const description = t(
      `${TP}.futureDescription`,
      'Stay up to date on the latest sneaker drops and upcoming sneaker releases on GOAT. {itemCount} styles from Air Jordan, Nike & adidas. Authenticity assured.',
      {
        itemCount,
      },
    );

    return {
      pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
      pageDescription: pageDescription || description,
    };
  }

  const { constructedListWithStartCase } = constructList({
    list: topThreeBrands,
    key: 'display_name',
  });

  const title = t(`${TP}.title`, '{year} Sneaker Releases', {
    year,
  });
  const description = t(
    `${TP}.description`,
    'Shop sneaker releases from {year} on GOAT. {itemCount} styles from {list}. Authenticity assured.',
    {
      year,
      itemCount,
      list: getText('', constructedListWithStartCase),
    },
  );

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
